import React from "react";
import "./HeaderBarcode.scss";

const HeaderBarcode = () => {
  return <div className="bc-container barcode">dstl-Thescienceinside</div>;
};

export default HeaderBarcode;
